exports.geocode = (address, zoom = 16) ->
    $.post 'backend/geocode',
        address: address,
        (result) ->
            result = $.parseJSON(result)
            if result.success or result.success is 'true'
                coords = [result.lat, result.lng]

                if coords?
                    App.map.setView(coords, zoom)

            return result
